import { EventList } from "../components/EventsList";

export default function Events() {
  return (
    <div className="container py-3">
      <h2>Events</h2>
      <EventList showPast={true} />
    </div>
  );
}